var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.972656 1.44067V5.80431M0.972656 1.44067H5.33629M0.972656 1.44067L6.06357 6.53158M0.972656 17.4407V13.077M0.972656 17.4407H5.33629M0.972656 17.4407L6.06357 12.3498M16.9727 1.44067L12.609 1.44067M16.9727 1.44067V5.80431M16.9727 1.44067L11.8817 6.53158M16.9727 17.4407H12.609M16.9727 17.4407V13.077M16.9727 17.4407L11.8817 12.3498",
    stroke: "#333333",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterior);
export default __webpack_public_path__ + "static/media/interior.b75bd06fd24a81805aced9b3f53830e3.svg";
export { ForwardRef as ReactComponent };